import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PostComposerPage from './pages/PostComposerPage';
import ContentCalendarPage from './pages/ContentCalendarPage';
import ContentLibraryPage from './pages/ContentLibraryPage';
import ProviderSettingsPage from './pages/ProviderSettingsPage';

const SmmRoutes = () => (
  <Routes>
    <Route path="" element={<Navigate to="compose" />} />
    <Route path="compose" element={<PostComposerPage />} />
    <Route path="calendar" element={<ContentCalendarPage />} />
    <Route path="library" element={<ContentLibraryPage />} />
    <Route path="settings" element={<ProviderSettingsPage />} />
  </Routes>
);

export default SmmRoutes;
